










import { defineComponent, computed } from "@vue/composition-api";
import { salesPointsFacade } from "@/store/modules/salesPoints/salesPoints.facade";
import { useRoute } from "@/router";
import { Content } from "@/core/dataTypes/types";
import SalesPointsMap from "@/views/salesPoints/components/salesPointsMap/SalesPointsMap.vue";

export default defineComponent({
  name: "EmatricaSalesPoints",
  components: {
    SalesPointsMap,
  },
  setup() {
    const route = useRoute();
    const content = computed<Content[] | undefined>(salesPointsFacade.content);
    const tenant = process.env.VUE_APP_TENANT_EMATRICA;

    salesPointsFacade.resetModule();

    salesPointsFacade.getContent(route.value.slug as string);

    return {
      content,
      tenant,
    };
  },
  metaInfo() {
    const actualContent = this.content
      ? (this.content as Content[])[0]
      : undefined;
    const title =
      (actualContent?.seoTitle as string) ?? (actualContent?.title as string);
    const description = actualContent?.seoLead as string;
    return {
      titleTemplate: `${title} | %s`,
      meta: [
        {
          vmid: "description",
          name: "description",
          content: description,
        },
      ],
    };
  },
});
